import { toRestErrorResponseData } from 'providers/tanstack-query-rest/errors'

export type AgentApiError = {
  code: string
  message: string
}

const isAgentApiError = (data: unknown): data is AgentApiError =>
  typeof data === 'object' &&
  data !== null &&
  'code' in data &&
  typeof data.code === 'string' &&
  'message' in data &&
  typeof data.message === 'string'

export const toAgentApiError = (error: unknown): AgentApiError | undefined => {
  const data: unknown = toRestErrorResponseData(error)

  return isAgentApiError(data) ? data : undefined
}

export const toAgentErrorMessage = (responseData: unknown): string | undefined =>
  isAgentApiError(responseData) ? responseData.message : undefined
